import { useEffect, useRef, useState } from 'react'
import { convertMISPApiResponse, convertDocUrlsToBase64, ClaimMsg } from 'utils/function'
import { ClaimStatus, EvaluationStatus, IncidentEnums, LossRunReportProps, ThreatStatus } from './enums'
import { Box, Flex } from 'components/elements'
import { useRaisedClaim } from '../api/raisedClaim'
import { useReEvaluationRequest } from '../api/reEvaluationRequest'
import { AxiosError } from 'axios'
import { yupResolver } from '@hookform/resolvers/yup'
import { reEvaluationSchema } from './SentinelOne/IncidentsDetails'
import { EvaluationReqProps, GalaxyImageData, InputFields, MISPDTO } from './type'
import { useForm } from 'react-hook-form'
import { useChainTransaction } from '../api/getThreatChainTransaction'
import { Button } from 'components/button'
import { CircularSpinnerCss, DetailContainer, DetailWrapper, InfoColumn, InlineTextCss, ShowLessTextCss, ToolTipcss, claimbgCss } from './style'
import { ModalbuttonCss, detailButtonCss } from 'features/insurance/components/InsurancePolicy'
import { TextField } from 'components/form'
import { UploadMultiDocument } from 'components/uploadDocument/uploadDocument'
import { DownArrowIcon, UpArrowIcon } from 'components/icons'
import { CircularProgress, Tooltip } from '@mui/material'
import LossRunReport from './LossRunReport'
import { IncidentDetail } from './CardDetail'
import Comments from './Comment'
import { Modal } from 'components/modal'
import SnackBar from 'components/SnackBar'
import { NotificationMessages, ValidationErrors } from 'utils/enum'
import { useReEvaluationRequestCove } from '../api/reEvaluationRequestCove'
import { useRaisedClaimCove } from '../api/raisedClaimCove'
import { useReEvaluationRequestNSightPatch } from '../api/reEvaluationRequestNSightPatch'
import { useRaisedClaimNSightPatch } from '../api/raisedClaimNSightPatch'
import { Circle } from 'features/insurance/pages/Insurance'
import MISPGalaxyImage from 'features/galaxyImage/MISPGalaxyImage'
import { useFetchMispData } from 'features/galaxyImage/api/MISPAPI'
import ViewExploreModal from './ViewExploreModal'
import { useRaisedClaimWindowsDefender } from '../api/windowDefender'
import { useReEvaluationRequestWindowsDefender } from '../api/windowDefender'
import WindowDefenderDetail from './Defender/WindowDefenderDetail'
import { TERMINOLOGY } from 'utils/enum'
import { useRaisedClaimSecureScore, useReEvaluationRequestSecureScore } from '../api/securescore'
type ApiResponse = {
  message: string
}
type CustomError = {
  response?: {
    data?: ApiResponse
  }
}

const EvaluationReq = (props: EvaluationReqProps) => {
  const parentGalaxyRef = useRef<HTMLDivElement>(null)

  const {
    claimRequestAmount,
    isClaimAPIFetched,
    evaluationStatus,
    row,
    showMore,
    claimRequestId,
    loadingReport,
    setShowMore,
    setShowCaseHistory,
    showCaseHistory,
    setLoadingReport,
    setIsChainTransactionLoading,
    setIsMISP,
    isMISP,
    isPrimaryService, //the service is primary then claim should be initated
    onExpand,
    threatStatus,
  } = props
  const [caseHistoryData, setCaseHistoryData] = useState<LossRunReportProps[] | null>(null)
  const [showComments, setShowComments] = useState(false)
  const [showOnChain, setShowOnChain] = useState(false)
  const [claimRaised, setClaimRaised] = useState(false)

  const [reEvaluation, setReEvaluation] = useState(false)
  const [evaluationForm, setReEvaluationForm] = useState(false)
  const [confirmClaim, setConfirmClaim] = useState(false)
  const [documentCount, setDocumentCount] = useState(1)
  const [selectedFileArray, setSelectedFileArray] = useState<(string | Blob)[]>([''])
  const [fileNameArray, setFileNameArray] = useState<(string | File)[]>([''])
  const [submitError, setSubmitError] = useState('')
  const [apiError, setApiError] = useState('')
  const [claimNotification, setClaimNotification] = useState<boolean>(false)
  const [reEvaluateNotification, setReEvaluateNotification] = useState<boolean>(false)
  const [acceptNotification, setAcceptNotification] = useState<boolean>(false)
  const [isAPIError, setIsAPIError] = useState<boolean>(false)
  const [hasDuplicateFiles, setHasDuplicateFiles] = useState(false)
  const [galaxyImageDataArray, setGalaxyImageDataArray] = useState<GalaxyImageData[]>()

  const lossRunReport = row?.insuranceDetail?.lossRunReport
  const ThreadInfo = row[IncidentEnums.THREAT_INFO]

  const claimStatus = evaluationStatus === EvaluationStatus.EDR ? row?.insuranceDetail?.claimStatus : row?.claimStatus
  const threatId = evaluationStatus === EvaluationStatus.EDR ? row?.threatId : row?.id || 0
  const re_evaluationCount = row?.reEvaluationRequestCount
  //claim re evaluation only once
  const re_evaluationCountLimit = 0
  // sentinelone  of React Query calls
  const {
    mutateAsync: reEvaluationProcess,
    isLoading: isEvaluating,
    isError: evaluateError,
    isSuccess: isSuccessReEvaluationProcess,
    status: statusReEvaluationEdr,
  } = useReEvaluationRequest()
  const { mutateAsync: raisedClaim, isLoading: isLoadingIncident, isError, isSuccess: isSuccessEdr, status: statusEdr } = useRaisedClaim()

  // cove of React Query calls
  const {
    mutateAsync: reEvaluationProcessCove,
    isLoading: isEvaluatingCove,
    isError: evaluateErrorCove,
    isSuccess: isSuccessReEvaluationProcessCove,
    status: statusReEvaluationCove,
  } = useReEvaluationRequestCove()
  const { mutateAsync: raisedClaimCove, isLoading: isLoadingCove, isError: isErrorCove, isSuccess: isSuccessCove, status: statusCove } = useRaisedClaimCove()
  //N Sight Patch Mang React Query calls

  const {
    mutateAsync: reEvaluationProcessNSightPatch,
    isLoading: isEvaluatingNSightPatch,
    isError: evaluateErrorNSightPatch,
    isSuccess: isSuccessReEvaluationProcessNSightPatch,
    status: statusReEvaluationNSight,
  } = useReEvaluationRequestNSightPatch()
  const {
    mutateAsync: raisedClaimNSightPatch,
    isLoading: isLoadingNSightPatch,
    isError: isErrorNSightPatch,
    isSuccess: isSuccessNSight,
    status: StatusNSight,
  } = useRaisedClaimNSightPatch()

  // windowDefender
  const {
    mutateAsync: reEvaluationProcessWindowDefender,
    isLoading: isEvaluatingWindowDefender,
    isError: evaluateErrorWindowDefender,
    isSuccess: isSuccessReEvaluationProcessWindowDefender,
    status: statusReEvaluationWindowDefender,
  } = useReEvaluationRequestWindowsDefender()
  const {
    mutateAsync: raisedClaimWindowDefender,
    isLoading: isLoadingWindowDefender,
    isError: isErrorWindowDefender,
    isSuccess: isSuccessWindowDefender,
    status: StatusWindowDefender,
  } = useRaisedClaimWindowsDefender()

  // secureScore
  const {
    mutateAsync: reEvaluationProcessSecureScore,
    isLoading: isEvaluatingSecureScore,
    isError: evaluateErrorSecureScore,
    isSuccess: isSuccessReEvaluationProcessSecureScore,
  } = useReEvaluationRequestSecureScore()
  const { mutateAsync: raisedClaimSecureScore, isLoading: isLoadingSecureScore, isError: isErrorSecureScore, isSuccess: isSuccessSecureScore } = useRaisedClaimSecureScore()

  const claimSuccessState = isSuccessEdr || isSuccessCove || isSuccessNSight || isSuccessWindowDefender || isSuccessSecureScore
  const claimLoadingState = isLoadingIncident || isLoadingCove || isLoadingNSightPatch || isLoadingWindowDefender || isLoadingSecureScore
  const claimErrorState = isError || isErrorCove || isErrorNSightPatch || isErrorWindowDefender || isErrorSecureScore

  const reEvaluationErrorState = evaluateError || evaluateErrorCove || evaluateErrorNSightPatch || evaluateErrorWindowDefender || evaluateErrorSecureScore
  const reEvaluationLoadingState = isEvaluating || isEvaluatingCove || isEvaluatingNSightPatch || isEvaluatingWindowDefender || isEvaluatingSecureScore
  const reEvaluationSuccessState =
    isSuccessReEvaluationProcess ||
    isSuccessReEvaluationProcessCove ||
    isSuccessReEvaluationProcessNSightPatch ||
    isSuccessReEvaluationProcessWindowDefender ||
    isSuccessReEvaluationProcessSecureScore
  const { data: threatChainTransaction, isLoading: dataLoading } = useChainTransaction({
    threatId: threatId,
  })
  const MISP_API_Params = {
    search: row?.sha1,
    isChainLinkCall: false,
    isEvaluationStatusEDR: evaluationStatus === EvaluationStatus.EDR,
  }
  const { data: misp_Data, isSuccess, isLoading: mispDataLoading } = useFetchMispData(MISP_API_Params)
  const threatChainTransactionData = threatChainTransaction?.data || ''
  const doc: Document = document
  const body = doc.querySelector('body')
  useEffect(() => {
    if (isSuccess) {
      const returnObject = convertMISPApiResponse(misp_Data)
      setGalaxyImageDataArray(returnObject)
    }
  }, [misp_Data, isSuccess])

  //on claim Raised, show notification and CLose the tab
  useEffect(() => {
    if (claimSuccessState) {
      setClaimNotification(true)
      setTimeout(() => {
        setClaimNotification(false)
        onExpand?.() //close the current open tab
        window.scrollTo(0, 0)
        window.scroll({
          behavior: 'smooth',
        })
      }, 2000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusEdr, statusCove, StatusNSight, StatusWindowDefender])
  //on claim confrim, show notification and CLose the tab
  useEffect(() => {
    if (reEvaluationSuccessState) {
      setAcceptNotification(true)
      setTimeout(() => {
        setAcceptNotification(false)
        onExpand?.() //close the current open tab
        window.scrollTo(0, 0)
        window.scroll({
          behavior: 'smooth',
        })
      }, 2000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusReEvaluationCove, statusReEvaluationEdr, statusReEvaluationNSight, statusReEvaluationWindowDefender])

  useEffect(() => {
    //remove the classes from body,applied bcz of modal view on chain
    !showOnChain && body?.classList.remove('overflow--hidden--modal')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showOnChain])
  useEffect(() => {
    //duplicate files doesnot exist
    if (!hasDuplicateFiles) setSubmitError('')
  }, [hasDuplicateFiles])
  useEffect(() => {
    setIsChainTransactionLoading(dataLoading)
  }, [dataLoading, setIsChainTransactionLoading])
  useEffect(() => {
    const pdfReport = async () => {
      setLoadingReport(true)
      if (lossRunReport) {
        const merchantDoc = await convertDocUrlsToBase64(lossRunReport?.merchantAction?.documentUrl?.urls)
        const reEvaluateDoc = await convertDocUrlsToBase64(lossRunReport?.reEvaluateClaim?.reEvaluateDocumentUrl?.urls)
        const reEvaluateMerchantDoc = await convertDocUrlsToBase64(lossRunReport?.merchantActionAtReEvaluateRequest?.documentUrl?.urls)
        let history
        if (evaluationStatus === EvaluationStatus.EDR) {
          history = {
            title: TERMINOLOGY.benefit.singular,
            threatName: ThreadInfo[IncidentEnums.THREAT_NAME],
            classification: ThreadInfo?.Classification,
            amount: `The total ${TERMINOLOGY.benefit.singular.toLowerCase()} available for this claim is $${lossRunReport?.planMaxCoverage}.`,
            time: ThreadInfo[IncidentEnums.CREATED_AT],
            show: lossRunReport?.caseStatus === 'Open' || lossRunReport?.caseStatus === 'Close' ? true : false,
          }
        } else {
          history = {
            title: TERMINOLOGY.benefit.singular,
            amount: `The total ${TERMINOLOGY.benefit.singular.toLowerCase()} available for this claim is $${lossRunReport?.planMaxCoverage}`,
            show: lossRunReport?.caseStatus === 'Open' || lossRunReport?.caseStatus === 'Close' ? true : false,
          }
        }
        setCaseHistoryData([
          history,
          {
            title: 'Evaluation Decision',
            description: lossRunReport?.merchantAction?.justification,
            documentUrl: merchantDoc,
            documentName: lossRunReport?.merchantAction?.documentUrl?.docNames,
            amount: `${
              lossRunReport?.merchantAction?.status === ClaimStatus.REJECTED
                ? `The total ${TERMINOLOGY.benefit.singular.toLowerCase()} for this claim has been disapproved`
                : `The total accepted ${TERMINOLOGY.benefit.singular.toLowerCase()} for this claim is $${lossRunReport?.merchantAction?.claimAmount}`
            }.`,
            lossAmount: `Total loss adjustment expense for this claim is $${lossRunReport?.merchantAction?.lossAdjustmentExpense}`,
            time: lossRunReport?.merchantAction?.date,
            show: lossRunReport?.merchantAction,
            status: lossRunReport?.merchantAction?.status,
          },
          {
            title: 'Re Evaluation Request',
            description: lossRunReport?.reEvaluateClaim?.reEvaluateJustification,
            documentUrl: reEvaluateDoc,
            documentName: lossRunReport?.reEvaluateClaim?.reEvaluateDocumentUrl?.docNames,
            show: lossRunReport?.reEvaluateClaim,
          },
          {
            title: 'Re Evaluation Decision',
            description: lossRunReport?.merchantActionAtReEvaluateRequest?.justification,
            documentUrl: reEvaluateMerchantDoc,
            documentName: lossRunReport?.merchantActionAtReEvaluateRequest?.documentUrl?.docNames,
            amount: `Re Evaluation ${TERMINOLOGY.benefit.singular.toLowerCase()} for this claim is $${lossRunReport?.merchantActionAtReEvaluateRequest?.claimAmount}.`,
            lossAmount: `Total loss adjustment expense for this claim is $${lossRunReport?.merchantActionAtReEvaluateRequest?.lossAdjustmentExpense}`,
            time: lossRunReport?.merchantActionAtReEvaluateRequest?.date,
            show: lossRunReport?.merchantActionAtReEvaluateRequest,
            status: lossRunReport?.merchantActionAtReEvaluateRequest?.status,
          },
          {
            title: 'Case Closed',
            show: lossRunReport?.caseStatus === 'Close' ? true : false,
          },
        ])
        setLoadingReport(false)
      } else {
        setCaseHistoryData(null)
        setLoadingReport(false)
      }
    }
    pdfReport()
  }, [ThreadInfo, claimStatus, evaluationStatus, lossRunReport, row?.createdAt, setLoadingReport])

  const {
    handleSubmit,
    register: reEvaluateForm,
    formState: { errors },
  } = useForm<InputFields>({
    resolver: yupResolver(reEvaluationSchema),
  })

  const handleError = (error: AxiosError | CustomError | unknown) => {
    if (error instanceof AxiosError) {
      setApiError(error.response?.data?.message)
    } else {
      setApiError('')
    }
  }
  const callRaisedClaim = (formId: number) => {
    let apiCall
    setApiError('')
    if (evaluationStatus === EvaluationStatus.EDR) apiCall = raisedClaim
    else if (evaluationStatus === EvaluationStatus.COVE) apiCall = raisedClaimCove
    else if (evaluationStatus === EvaluationStatus.NSIGHT) apiCall = raisedClaimNSightPatch
    else if (evaluationStatus === EvaluationStatus.WINDOW_DEFENDER) apiCall = raisedClaimWindowDefender
    else if (evaluationStatus === EvaluationStatus.SECURE_SCORE) apiCall = raisedClaimSecureScore

    if (apiCall) {
      apiCall(
        { id: formId },
        {
          onSuccess: () => {
            setClaimRaised(false)
            setReEvaluationForm(false)
          },
          onError: error => {
            handleError(error)
          },
        }
      )
    }
  }
  const onConfirmClaim = async () => {
    const bodyFormData = new FormData()
    bodyFormData.append('id', claimRequestId.toString())
    bodyFormData.append('claimStatus', 'Accepted')
    let apiCall
    if (evaluationStatus === EvaluationStatus.EDR) apiCall = reEvaluationProcess
    else if (evaluationStatus === EvaluationStatus.COVE) apiCall = reEvaluationProcessCove
    else if (evaluationStatus === EvaluationStatus.NSIGHT) apiCall = reEvaluationProcessNSightPatch
    else if (evaluationStatus === EvaluationStatus.WINDOW_DEFENDER) apiCall = reEvaluationProcessWindowDefender
    else if (evaluationStatus === EvaluationStatus.SECURE_SCORE) apiCall = reEvaluationProcessSecureScore

    if (apiCall) {
      apiCall(bodyFormData, {
        onSuccess: () => {
          setReEvaluationForm(false)
          setApiError('')
          setSubmitError('')
          setReEvaluation(false)
          setConfirmClaim(false)
        },
        onError: error => {
          handleError(error)
        },
      })
    }
  }
  const onSubmit = async (data: { description: string | Blob }) => {
    setSubmitError('')

    if (hasDuplicateFiles) {
      setSubmitError(ValidationErrors.FILE_DUPLICATION)
      return
    }
    const bodyFormData = new FormData()
    bodyFormData.append('id', claimRequestId.toString())
    bodyFormData.append('reEvaluateJustification', data.description)
    selectedFileArray.forEach(file => {
      bodyFormData.append('supportingDocument', file)
    })
    bodyFormData.append('claimStatus', 'Re-Evaluate')
    let apiCall
    if (evaluationStatus === EvaluationStatus.EDR) apiCall = reEvaluationProcess
    else if (evaluationStatus === EvaluationStatus.COVE) apiCall = reEvaluationProcessCove
    else if (evaluationStatus === EvaluationStatus.NSIGHT) apiCall = reEvaluationProcessNSightPatch
    else if (evaluationStatus === EvaluationStatus.WINDOW_DEFENDER) apiCall = reEvaluationProcessWindowDefender
    else if (evaluationStatus === EvaluationStatus.SECURE_SCORE) apiCall = reEvaluationProcessSecureScore

    if (apiCall) {
      apiCall(bodyFormData, {
        onSuccess: () => {
          setReEvaluateNotification(true)
          setReEvaluationForm(false)
          setReEvaluation(false)
          setApiError('')
          setSubmitError('')
        },
        onError: error => {
          handleError(error)
        },
      })
    }
  }

  let mispInfo: MISPDTO | null
  if (row?.mispData) {
    mispInfo = row.mispData
  } else {
    mispInfo = null
  }
  return (
    <>
      <Box css={{ width: '100%' }}>
        {!!lossRunReport && isPrimaryService && (
          <Box css={{ mb: '1.5rem' }}>
            <Box as="h3" className="primary" css={InlineTextCss} style={{ alignItems: 'baseline', margin: 0 }}>
              Status:
              <Box as="h4" css={{ color: '$white', m: 0 }}>
                {ClaimMsg(claimStatus)}
              </Box>
            </Box>
            <>
              {claimRequestAmount && (
                <Box css={{ width: '229px', backgroundImage: '$transparentGradient' }}>
                  <Flex direction={'column'} css={{ padding: '1rem' }}>
                    <Box as="h3" css={InlineTextCss} style={{ alignItems: 'baseline' }}>
                      Claim Amount:
                    </Box>
                    <Box as="h2" className="primary" css={{ m: 0 }}>
                      ${claimRequestAmount}
                    </Box>
                  </Flex>
                </Box>
              )}

              {(threatStatus === ThreatStatus.USER_CONFIRMATION || threatStatus === ThreatStatus.BLOCK_CREATION || threatStatus === ThreatStatus.CLAIM_RESOLVED) && (
                <Flex direction={'column'} wrap={'wrap'} css={{ mt: '$4' }}>
                  <Box as="p" css={{ fontSize: '1.25rem', fontWeight: '$semibold' }}>
                    Your block creation is&nbsp;
                    {threatStatus === ThreatStatus.USER_CONFIRMATION ? (
                      <Box as="span" css={{ color: '$primary', fontSize: '1.25rem', fontWeight: '$semibold' }}>
                        In-Progress
                      </Box>
                    ) : (
                      <Box as="span" css={{ color: '$green4', fontSize: '1.25rem', fontWeight: '$semibold' }}>
                        Successful
                      </Box>
                    )}
                  </Box>
                  <Box as="span" css={{ textDecoration: 'underline', color: '$primary', wordBreak: 'break-all' }}>
                    Transaction#: {threatChainTransactionData?.dlt_hash}
                  </Box>
                </Flex>
              )}
            </>
          </Box>
        )}
        {row?.regOnChain === 'Broadcasted' && (
          <Box>
            {
              <Button onClick={() => setShowOnChain(true)} id="view_on_chain_button">
                View on chain
              </Button>
            }
          </Box>
        )}

        {/* if primary then claim can be initated by user  and have history tab*/}
        {!isClaimAPIFetched ? (
          <Flex justify={'center'} align={'center'}>
            <CircularProgress size={30} sx={CircularSpinnerCss} />
          </Flex>
        ) : (
          isPrimaryService &&
          (claimStatus === ClaimStatus.APPLICABLE || claimStatus === ClaimStatus.APPROVED || claimStatus === ClaimStatus.DISAPPROVED) && (
            <>
              {claimStatus !== ClaimStatus.DISAPPROVED && (
                <>
                  {!claimRequestAmount && (
                    <InfoColumn css={claimbgCss} style={{ marginBottom: '1.5rem' }}>
                      <Box as="p" css={{ marginBottom: 8 }} className="t-key">
                        Claim Applicable
                      </Box>
                      <p className="t-value claim">{ClaimStatus.PENDING}</p>
                    </InfoColumn>
                  )}
                </>
              )}
              {claimRequestAmount || claimStatus === ClaimStatus.DISAPPROVED ? (
                !evaluationForm && (
                  <Flex css={ModalbuttonCss} wrap="wrap" style={{ justifyContent: 'flex-start' }}>
                    {re_evaluationCount === re_evaluationCountLimit && (
                      <Button bordered={true} type="button" onClick={() => setReEvaluationForm(true)} id="re_evaluate_button">
                        Re-Evaluate
                      </Button>
                    )}
                    <Button type="button" onClick={() => setConfirmClaim(true)} id="confirm_claim">
                      Confirm
                    </Button>
                  </Flex>
                )
              ) : (
                <Button onClick={() => setClaimRaised(true)} id="initiate_claim_button">
                  Initiate Claim
                </Button>
              )}
            </>
          )
        )}

        {evaluationForm && (
          <Flex as="form" direction="column" css={{ gap: '$4', maxWidth: '430px' }} onSubmit={handleSubmit(onSubmit)}>
            {!!submitError && (
              <Box as="p" css={{ color: '$error' }}>
                {submitError}
              </Box>
            )}
            <input style={{ display: 'none' }} value={threatId} {...reEvaluateForm('formId')} />
            <TextField
              label="Justification for re evaluate claim amount"
              as="Textarea"
              rows="4"
              isTextarea={true}
              fullWidth
              placeholder="Please type Justification..."
              error={!!errors.description}
              helperText={errors.description?.message}
              {...reEvaluateForm('description')}
            />

            <UploadMultiDocument
              error={!!errors?.documentFile}
              errorText={errors?.documentFile?.message}
              formField={reEvaluateForm}
              formName={'documentFile'}
              setFileNameArray={setFileNameArray}
              setSelectedFileArray={setSelectedFileArray}
              setDocumentCount={setDocumentCount}
              documentCount={documentCount}
              selectedFileArray={selectedFileArray}
              fileNameArray={fileNameArray}
              setHasDuplicateFiles={setHasDuplicateFiles}
            />

            <Flex css={ModalbuttonCss}>
              <Button bordered={true} type="button" onClick={() => setReEvaluationForm(false)}>
                Cancel
              </Button>
              <Button disabled={reEvaluationLoadingState} type="button" onClick={() => setReEvaluation(true)}>
                {reEvaluationLoadingState ? <CircularProgress size={18} sx={{ color: 'var(--colors-white) !important' }} /> : 'SUBMIT'}
              </Button>
            </Flex>
          </Flex>
        )}
        {isPrimaryService && (
          <Box id={`${caseHistoryData?.length ? 'divToDownload2' : 'no-data'}`}>
            <Box css={detailButtonCss} style={{ marginTop: '2rem' }} onClick={() => setShowCaseHistory(!showCaseHistory)} data-html2canvas-ignore="true">
              <Box as="h4" css={ShowLessTextCss}>
                {`${showCaseHistory ? 'Hide' : 'Show'} Case History`}
              </Box>
              {showCaseHistory ? <UpArrowIcon fontSize={22} /> : <DownArrowIcon fontSize={22} />}
            </Box>
            {showCaseHistory && (
              <Box style={{ padding: '1.5rem 0' }}>
                {loadingReport ? (
                  <CircularProgress />
                ) : caseHistoryData ? (
                  caseHistoryData?.map((item, idx: number) => (
                    <LossRunReport
                      key={idx}
                      title={item.title}
                      threatName={item.threatName}
                      classification={item.classification}
                      description={item.description}
                      imageSrc={item.documentUrl}
                      documentName={item.documentName}
                      amount={item.amount}
                      lossAmount={item.lossAmount}
                      time={item.time}
                      show={!!item.show}
                      status={item.status}
                    />
                  ))
                ) : (
                  <Box as="h4" css={{ textAlign: 'center', m: 0 }}>
                    No Data History
                  </Box>
                )}
              </Box>
            )}
          </Box>
        )}
        {evaluationStatus === EvaluationStatus.WINDOW_DEFENDER && (
          <Box id="divToDownload3">
            <Box css={detailButtonCss} style={{ marginTop: '1rem' }} onClick={() => setShowMore(!showMore)} data-html2canvas-ignore="true">
              <Box as="h4" css={ShowLessTextCss}>
                {`Show ${showMore ? 'Less' : 'More'} Details`}
              </Box>
              {showMore ? <UpArrowIcon fontSize={22} /> : <DownArrowIcon fontSize={22} />}
            </Box>

            {showMore && row?.threatData && <WindowDefenderDetail fields={row?.threatData} />}
          </Box>
        )}

        {evaluationStatus === EvaluationStatus.EDR && (
          <>
            <Box id="divToDownload3">
              <Box css={detailButtonCss} style={{ marginTop: '1rem' }} onClick={() => setShowMore(!showMore)} data-html2canvas-ignore="true">
                <Box as="h4" css={ShowLessTextCss}>
                  {`Show ${showMore ? 'Less' : 'More'} Details`}
                </Box>
                {showMore ? <UpArrowIcon fontSize={22} /> : <DownArrowIcon fontSize={22} />}
              </Box>

              {showMore && (
                <>
                  {Object.keys(row)?.map(sectionName => {
                    if (
                      sectionName !== IncidentEnums.INSURANCE_DETAIL &&
                      sectionName !== IncidentEnums.THREAT_STATUS &&
                      sectionName !== IncidentEnums.THREAT_ID &&
                      sectionName !== IncidentEnums.COMPANY_NAME &&
                      sectionName !== IncidentEnums.PLAN_NAME &&
                      sectionName !== IncidentEnums.COMPANY_URL &&
                      sectionName !== IncidentEnums.MISP_DATA
                    ) {
                      if (!row[sectionName]) return <></>
                      return <IncidentDetail key={sectionName} title={sectionName} fields={row[sectionName]} />
                    } else return <></>
                  })}
                </>
              )}
            </Box>

            <Box id="divToDownload4">
              <Box
                css={detailButtonCss}
                style={{ marginTop: '1rem' }}
                onClick={() => {
                  if (mispInfo) setIsMISP && setIsMISP(!isMISP)
                }}
                data-html2canvas-ignore="true"
              >
                <Box as="h4" css={ShowLessTextCss}>
                  {` Incident Attribution (Source: `}&nbsp;
                  <Box as="a" href="https://misp-project.org/" target="_blank" css={{ color: '$primary', cursor: 'pointer', textDecoration: 'underline' }}>
                    MISP
                  </Box>
                  {`) Details`}
                </Box>
                <Flex wrap={'wrap'} justify={'end'}>
                  <Tooltip
                    PopperProps={{ sx: ToolTipcss }}
                    title={
                      <Box as="p" css={{ fontWeight: 'bold', color: '$black' }}>
                        {mispInfo ? 'Data available ' : 'Nonapplicable incident'}
                      </Box>
                    }
                    placement="bottom"
                    enterTouchDelay={0}
                  >
                    <Box css={{ alignSelf: 'center' }}>
                      <Circle className={mispInfo ? 'active' : 'cancelled'} css={{ width: '0.4rem', height: '0.4rem' }} />
                    </Box>
                  </Tooltip>
                  {isMISP ? (
                    <>
                      <UpArrowIcon fontSize={22} />
                    </>
                  ) : (
                    <>
                      <DownArrowIcon fontSize={22} />
                    </>
                  )}
                </Flex>
              </Box>

              {isMISP && mispInfo && (
                <>
                  <DetailWrapper css={{ mt: '$3' }}>
                    <Box as="h2" css={{ mb: '1.5rem' }}>
                      MISP Information
                    </Box>
                    <DetailContainer>
                      <InfoColumn>
                        <p className="t-key">Info</p>
                        <p>{mispInfo?.info}</p>
                      </InfoColumn>
                      <InfoColumn>
                        <p className="t-key">Category</p>
                        <p>{mispInfo?.category}</p>
                      </InfoColumn>
                    </DetailContainer>
                  </DetailWrapper>
                  <Box as="h2" css={{ mt: '2rem' }}>
                    MISP Galaxy Image
                  </Box>
                  <Box ref={parentGalaxyRef}>
                    {mispDataLoading ? (
                      <Flex justify={'center'} css={{ m: '1rem' }}>
                        <CircularProgress sx={CircularSpinnerCss} />
                      </Flex>
                    ) : (
                      galaxyImageDataArray && galaxyImageDataArray.length > 0 && <MISPGalaxyImage parentRef={parentGalaxyRef} galaxyImageDataArray={galaxyImageDataArray} />
                    )}
                  </Box>
                </>
              )}
            </Box>
          </>
        )}

        <Box css={detailButtonCss} style={{ marginTop: '1rem' }} onClick={() => setShowComments(!showComments)}>
          <Box as="h4" css={ShowLessTextCss}>
            {`${showComments ? 'Hide' : 'Show'} Comments`}
          </Box>
          {showComments ? <UpArrowIcon fontSize={22} /> : <DownArrowIcon fontSize={22} />}
        </Box>

        {showComments && (
          <>
            <Comments row={row} showMore={showMore} />
          </>
        )}
        {showOnChain && (
          <ViewExploreModal
            showOnChain={showOnChain}
            setShowOnChain={setShowOnChain}
            isLoading={claimLoadingState}
            threatChainTransactionData={threatChainTransactionData}
            incidentListRow={row}
            evaluationStatus={evaluationStatus}
          />
        )}
        {/* Raise A Claim Modal */}
        <Modal
          active={claimRaised}
          hideModal={() => {
            setApiError('')
            setClaimRaised(false)
          }}
          onAccept={() => callRaisedClaim(threatId)}
          isLoading={claimLoadingState}
          title={'Confirm Initiate Claim'}
          description={'Are you sure want to initiate this claim?'}
          hasError={claimErrorState}
          apiErrorText={apiError}
          acceptText={'Initiate Claim'}
        ></Modal>
        {/* ReEvaluation Modal */}
        <Modal
          active={reEvaluation}
          hideModal={() => {
            setSubmitError('')
            setApiError('')
            setReEvaluation(false)
          }}
          onAccept={handleSubmit(onSubmit)}
          isLoading={reEvaluationLoadingState}
          title={'Confirm Re-evaluation'}
          description={'Are you sure you want to re-evaluate this claim?'}
          hasError={reEvaluationErrorState || !!submitError}
          apiErrorText={apiError || submitError}
          isForm={true}
          acceptText={'Re-evaluate'}
        ></Modal>
        {/* Confirm Claim Modal */}
        <Modal
          active={confirmClaim}
          hideModal={() => {
            setConfirmClaim(false)
            setSubmitError('')
            setApiError('')
          }}
          onAccept={onConfirmClaim}
          isLoading={reEvaluationLoadingState}
          title={'User Confirmation'}
          description={'Are you sure you want to accept this claim amount?'}
          hasError={reEvaluationErrorState}
          apiErrorText={apiError}
          isForm={true}
          acceptText={'Confirm'}
        ></Modal>

        <SnackBar open={claimNotification} onClose={() => setClaimNotification(false)} text={NotificationMessages.INITIATE_CLAIM} severity={'success'} />
        <SnackBar open={reEvaluateNotification} onClose={() => setReEvaluateNotification(false)} text={NotificationMessages.REEVALUATE_CLAIM} severity={'success'} />
        <SnackBar open={acceptNotification} onClose={() => setAcceptNotification(false)} text={NotificationMessages.ACCEPT_CLAIM} severity={'success'} />
        <SnackBar open={isAPIError} onClose={() => setIsAPIError(false)} text={`${apiError}`} severity={'error'} />
      </Box>
    </>
  )
}

export default EvaluationReq